export enum UserStatusEnums {
    Online = 1,
    Offline = 2,
    Idle = 3,
    Busy = 4,
}